import * as React from "react";

function Logo(props) {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 162 119"
      fill="none"
      {...props}
    >
      <g clipPath="url(#prefix__clip0_2677_202)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M89.894 18.996a6.392 6.392 0 003.572-1.087 6.465 6.465 0 002.371-2.902 6.521 6.521 0 00.371-3.741 6.49 6.49 0 00-1.754-3.318 6.412 6.412 0 00-3.288-1.777 6.381 6.381 0 00-3.714.363 6.437 6.437 0 00-2.888 2.381 6.51 6.51 0 00.791 8.175 6.41 6.41 0 004.54 1.906zM99.469 27.756c-1.482-4.596-3.226-7.398-8.397-8.04-2.442-.307-5.982-.281-8.145 1.195h-.052l-.297.22-.087.07-.227.202c-.065.063-.126.13-.183.202l-.209.229-.113.149a19.541 19.541 0 00-1.579 2.416 35.73 35.73 0 00-2.781 8.84c0 .254-.148.878-.27 1.756-.41 2.074-.777 4.63.217 4.824 1.849.36 4.456-5.175 5.023-7.222 0-.15.13-.404.244-.72-.75 9.787-2.293 22.843-.872 29.767.21 1.072 2.102 1.002 2.616.176 1.195-1.758 2.494-11.537 3.035-17.257.06-.518.185-1.026.375-1.51.445-.255.706-.22.872 0 0 0 .122 1.757.122 2.547 0 2.513 0 15.895 1.038 16.922.872.88 2.136 0 2.424-.738 1.299-3.453 1.212-8.425 1.456-12.054.47-6.414.872-12.714.96-19.172a37.215 37.215 0 001.874 5.72c.54.975 2.851 5.158 4.264 4.156 1.683-1.195-.724-10.895-1.308-12.678zM58.86 28.248a6.07 6.07 0 003.391-1.037 6.14 6.14 0 002.248-2.76 6.193 6.193 0 00.348-3.554 6.164 6.164 0 00-1.671-3.149 6.09 6.09 0 00-3.125-1.683 6.062 6.062 0 00-3.527.35 6.115 6.115 0 00-2.74 2.265 6.183 6.183 0 00.76 7.766 6.08 6.08 0 004.316 1.802z"
          fill="#888483"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M73.693 34.855a36.59 36.59 0 00-7.43-4.815 7.546 7.546 0 00-7.917.589c-2.616 2.161-3.872 5.122-4.884 8.303-.253.773-2.476 7.907-.75 7.907.768 0 2.19-1.845 2.616-2.495.61-.879 1.396-2.364 2.207-3.857a15.164 15.164 0 00-.393 2.442c-.174 2.047-2.154 13.882-.715 13.768 1.368.311 2.766.473 4.168.483.707 2.636 1.744 6.467 3.157 6.467s1.622-3.734 1.474-6.897a21.323 21.323 0 002.058-.51c.627 2.206 2.17 6.599 3.104 6.529.48-.053 1.011.237 1.386-.932.454-1.362.14-4.806-.226-7.424a16.398 16.398 0 002.616-1.863c.2-.527-2.616-8.224-5.363-14.058.606.284 1.226.536 1.857.756 1.635.586 3.358.883 5.093.879 1.316 0 1.5.122 2.153-.826.654-.95-3.426-3.805-4.211-4.446zM47.916 43.079c0-.796-.234-1.574-.673-2.236a4 4 0 00-1.792-1.482 3.965 3.965 0 00-4.352.872 4.052 4.052 0 00-.866 4.385 4.016 4.016 0 001.47 1.806 3.973 3.973 0 003.75.375 3.984 3.984 0 001.296-.872 4.018 4.018 0 001.167-2.848z"
          fill="#888483"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M52.556 57.444c-.323-.764-1.744-3.989-2.616-5.562 1.09.317 2.493.326 2.973-.254a6.277 6.277 0 00.48-2.32c.052-.826-.088-4.042-1.587-2.276a4.413 4.413 0 00-.75 1.95c-3.331-2.17-4.526-1.967-6.4-1.088-2.957 1.379-3.245 11.65-1.745 12.01.794.185 1.596-3.611 2.04-5.403 0 .255.07.492.114.685.698 3.321 1.36 7.908 2.616 10.991.34.88.924 1.556 1.814.73.601-.554.07-4.868-.358-7.811l.131-.053s3.314 5.465 3.593 5.799c.279.334.715.94 1.377.562 1.256-.72-1.273-6.862-1.682-7.96zM33.964 55.414a3.73 3.73 0 002.08-.645 3.773 3.773 0 001.373-1.701 3.804 3.804 0 00-.828-4.112 3.724 3.724 0 00-4.087-.805 3.757 3.757 0 00-1.678 1.395 3.799 3.799 0 00-.627 2.1 3.793 3.793 0 001.105 2.674 3.74 3.74 0 002.662 1.094z"
          fill="#888483"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M40.435 59.412c.282.152.573.287.872.404 1.57.65 3.156 0 1.866-1.098-.567-.5-.925-.984-1.456-1.52-2.05-2.065-5.346-2.54-7.508-.562a9.873 9.873 0 00-2.259 4.226c-.41 1.432-1.622 2.223-1.7 2.908-.053.518.872.879 1.98.43a5.13 5.13 0 002.293-2.011c.305 1.423.976 3.461 1.15 4.322.14.65 1.605 5.14 2.372 5.14 1.064 0 1.064-1.001 1.212-1.977a18.905 18.905 0 000-4.287c.192.29.498 1.054.602 1.186.61.73 2.232 2.996 3.244 2.636 1.247-.466-.41-4.885-.715-5.746a15.159 15.159 0 00-1.953-4.05zM116.185 38.624c.95 0 1.879-.284 2.668-.817a4.814 4.814 0 001.766-2.174 4.865 4.865 0 00-1.055-5.27 4.783 4.783 0 00-2.465-1.315 4.76 4.76 0 00-2.773.29 4.806 4.806 0 00-2.146 1.794 4.864 4.864 0 00.626 6.09 4.778 4.778 0 003.379 1.402zM118.165 41.638a10.695 10.695 0 00-3.323-1.977 1.355 1.355 0 01-.122-.106 2.617 2.617 0 00-.383-.22c-2.843-1.344-12.208-1.045-13.534 1.108-.148.228-.148.826.584 1.256 1.212.712 5.851.984 7.186.43-.175 0-3.549 5.562-4.029 6.213a31.642 31.642 0 00-2.171 3.373c-.253.431-2.32 4.112-2.128 4.393a7.432 7.432 0 002.041 1.828 23.683 23.683 0 00-1.413 4.833c-.105 1.599.872 2.126 2.223 1.335 1.047-.606 2.276-2.557 3.157-4.253.669.23 1.35.421 2.041.572-.131 1.959-.332 4.331.383 5.728.271.519 1.518.448 1.997-.448a17.81 17.81 0 001.596-4.973 8.058 8.058 0 002.023-.422c.767-.518 2.014-11.299 2.206-14.725 1.465 2.196 4.508 6.15 5.302 6.255.584 0 1.029.282 1.029-1.045-.018-2.381-2.171-7.011-4.665-9.155zM120.981 70.966c4.238-5.781 0-11.958-1.43-14.594-1.814 1.503-3.976 8.567.611 13.47.209.21.749 1.238.819 1.124zM121.923 70.984c1.351-4.2 5.903-5.096 8.72-4.033-3.2 6.572-7.962 4.393-8.72 4.033zM130.783 58.92a2.307 2.307 0 011.017 2.77 2.29 2.29 0 01-.999 1.207 2.262 2.262 0 01-1.536.276 2.668 2.668 0 01-1.244 1.613 2.634 2.634 0 01-2.013.254 2.656 2.656 0 01-1.601-1.254 2.69 2.69 0 01-.252-2.028h-.078a2.397 2.397 0 01-1.352-.937 2.43 2.43 0 01.245-3.098c.395-.405.92-.656 1.482-.71a.626.626 0 000-.193c.1-.395.319-.75.626-1.017a1.971 1.971 0 013.071.64 1.805 1.805 0 011.744-.563c.463.122.861.423 1.107.837.246.413.321.908.21 1.377a2.132 2.132 0 01-.48.879l.053-.053zM65.383 4.56c-.637-1.696.871-4.261 2.354-4.314 1.482-.053 2.372.703 2.442 3.734 0 .756-.872 5.623-1.797 6.537-2.511.202-10.603-3.409-8.205-6.81 1.125-1.572 3.837-.368 5.232.88l-.026-.027zM73.623 14.234c-1.02-.572-4.081-4.393-1.744-5.457a1.499 1.499 0 011.772.525c.13.182.219.39.26.609.06-1.151 2.502-1.687 2.616.641 0 .993-1.744 3.11-2.887 3.682h-.017z"
          fill="#888483"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M90.095 18.75a6.392 6.392 0 003.572-1.087 6.465 6.465 0 002.37-2.903 6.52 6.52 0 00.371-3.74 6.491 6.491 0 00-1.754-3.318 6.412 6.412 0 00-3.288-1.777 6.382 6.382 0 00-3.714.363 6.437 6.437 0 00-2.887 2.381 6.51 6.51 0 00.79 8.175 6.41 6.41 0 004.54 1.906z"
          fill="url(#prefix__paint0_radial_2677_202)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M99.67 27.518c-1.483-4.595-3.227-7.398-8.398-8.048-2.441-.307-5.982-.272-8.144 1.195h-.053l-.296.229a.344.344 0 00-.087.07c-.08.06-.155.124-.227.193-.07.07-.122.14-.183.211a2.692 2.692 0 00-.21.228l-.113.141c-.581.77-1.109 1.58-1.578 2.425a35.555 35.555 0 00-2.782 8.786c0 .255-.14.931-.27 1.757-.41 2.074-.776 4.64.218 4.824 1.857.36 4.456-5.166 5.023-7.213 0-.159.13-.413.244-.73-.75 9.788-2.294 22.844-.872 29.768.209 1.08 2.101 1.002 2.616.176 1.194-1.758 2.494-11.537 3.034-17.248.064-.52.19-1.03.375-1.52.445-.246.715-.21.872 0 0 0 .122 1.758.122 2.557 0 2.513 0 15.894 1.038 16.913.872.88 2.136 0 2.424-.737 1.3-3.445 1.212-8.418 1.456-12.046.471-6.423.872-12.714.96-19.172a37.884 37.884 0 001.874 5.72c.541.966 2.852 5.149 4.265 4.147 1.691-1.15-.742-10.85-1.308-12.626z"
          fill="url(#prefix__paint1_radial_2677_202)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M59.07 28.002c1.207 0 2.387-.361 3.39-1.037a6.14 6.14 0 002.249-2.76 6.194 6.194 0 00.347-3.554 6.165 6.165 0 00-1.67-3.149 6.09 6.09 0 00-3.126-1.683 6.061 6.061 0 00-3.527.35 6.114 6.114 0 00-2.739 2.265 6.184 6.184 0 00.76 7.766 6.08 6.08 0 004.315 1.802z"
          fill="url(#prefix__paint2_radial_2677_202)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M73.893 34.609a36.595 36.595 0 00-7.43-4.815 7.547 7.547 0 00-7.917.597c-2.616 2.153-3.872 5.114-4.883 8.294-.253.774-2.477 7.908-.75 7.908.767 0 2.189-1.854 2.616-2.495.61-.879 1.395-2.364 2.206-3.866a15.164 15.164 0 00-.392 2.443c-.175 2.047-2.154 13.882-.716 13.776 1.369.311 2.766.473 4.169.483.706 2.636 1.744 6.467 3.156 6.467 1.413 0 1.622-3.743 1.474-6.897a24.26 24.26 0 002.058-.51c.628 2.197 2.171 6.599 3.104 6.528.48-.052 1.012.229 1.387-.94.453-1.361.14-4.797-.227-7.415a17.146 17.146 0 002.616-1.863c.2-.527-2.616-8.224-5.363-14.058.606.284 1.226.536 1.858.756 1.634.586 3.357.883 5.092.878 1.317 0 1.5.132 2.154-.825.654-.958-3.427-3.796-4.212-4.446z"
          fill="url(#prefix__paint3_radial_2677_202)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M48.117 42.833c0-.796-.234-1.574-.673-2.236a4 4 0 00-1.793-1.482 3.965 3.965 0 00-4.352.872 4.052 4.052 0 00-.866 4.385 4.018 4.018 0 001.471 1.806 3.972 3.972 0 002.22.679 3.951 3.951 0 002.828-1.174 4.01 4.01 0 001.165-2.85z"
          fill="url(#prefix__paint4_radial_2677_202)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M52.756 57.207c-.323-.773-1.744-3.998-2.616-5.562 1.09.316 2.494.325 2.973-.263a6.19 6.19 0 00.48-2.311c.052-.826-.087-4.042-1.587-2.285a4.359 4.359 0 00-.75 1.96c-3.331-2.17-4.526-1.977-6.4-1.099-2.956 1.389-3.244 11.66-1.745 12.02.803.176 1.596-3.62 2.041-5.412 0 .254.07.5.114.685.697 3.321 1.36 7.907 2.616 10.992.34.878.924 1.563 1.813.737.602-.553.07-4.876-.357-7.82h.13s3.314 5.457 3.602 5.8c.288.342.706.931 1.369.553 1.255-.764-1.238-6.906-1.683-7.995z"
          fill="url(#prefix__paint5_radial_2677_202)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M34.165 55.177a3.738 3.738 0 002.087-.643 3.781 3.781 0 001.38-1.703 3.814 3.814 0 00-.824-4.125 3.732 3.732 0 00-4.098-.811 3.765 3.765 0 00-1.684 1.399 3.807 3.807 0 00-.628 2.105 3.794 3.794 0 001.102 2.68 3.739 3.739 0 002.665 1.098z"
          fill="url(#prefix__paint6_radial_2677_202)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M40.635 59.166c.282.154.573.289.872.404 1.57.65 3.157 0 1.866-1.09-.566-.5-.924-.992-1.456-1.528-2.05-2.065-5.345-2.53-7.508-.553a9.846 9.846 0 00-2.258 4.217c-.41 1.44-1.622 2.223-1.692 2.908-.061.519.872.879 1.97.43a5.115 5.115 0 002.224-2.011c.306 1.414.977 3.453 1.151 4.322.14.642 1.605 5.132 2.372 5.132 1.064 0 1.064-1.002 1.212-1.969a18.983 18.983 0 000-4.296c.192.299.497 1.054.602 1.186.61.738 2.232 2.996 3.244 2.636 1.247-.466-.41-4.885-.715-5.746a15.168 15.168 0 00-1.884-4.042z"
          fill="url(#prefix__paint7_radial_2677_202)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M116.386 38.378a4.771 4.771 0 002.67-.806 4.823 4.823 0 001.774-2.167 4.868 4.868 0 00-1.032-5.273 4.763 4.763 0 00-5.232-1.05 4.808 4.808 0 00-2.154 1.784 4.862 4.862 0 00.597 6.094 4.776 4.776 0 003.377 1.418z"
          fill="url(#prefix__paint8_radial_2677_202)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M118.365 41.4a10.677 10.677 0 00-3.322-1.976 1.324 1.324 0 00-.122-.106 2.627 2.627 0 00-.384-.22c-2.843-1.344-12.208-1.045-13.533 1.108-.149.237-.149.825.584 1.256 1.212.72 5.851.984 7.185.43-.174 0-3.549 5.57-4.029 6.212a30.912 30.912 0 00-2.171 3.383c-.253.43-2.319 4.112-2.128 4.393a7.459 7.459 0 002.041 1.836 23.547 23.547 0 00-1.413 4.833c-.104 1.599.872 2.117 2.233 1.327 1.037-.607 2.267-2.548 3.148-4.253.668.23 1.349.421 2.04.571-.131 1.96-.331 4.332.384 5.729.27.518 1.517.448 1.997-.448a17.666 17.666 0 001.595-4.973 8.437 8.437 0 002.023-.413c.776-.527 2.015-11.3 2.206-14.735 1.465 2.206 4.509 6.15 5.302 6.256.585 0 1.029.29 1.029-1.045-.017-2.4-2.171-7.03-4.665-9.164z"
          fill="url(#prefix__paint9_radial_2677_202)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M121.182 70.729c4.238-5.782 0-11.967-1.43-14.603-1.814 1.511-3.977 8.567.61 13.47.209.219.75 1.238.82 1.133z"
          fill="url(#prefix__paint10_radial_2677_202)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M122.124 70.729c1.351-4.2 5.903-5.105 8.72-4.042-3.209 6.572-7.971 4.393-8.72 4.042z"
          fill="url(#prefix__paint11_radial_2677_202)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M130.983 58.674c.437.245.781.628.978 1.091.197.463.237.978.112 1.466a2.303 2.303 0 01-.975 1.371 2.27 2.27 0 01-1.641.333 2.685 2.685 0 01-1.248 1.612c-.611.35-1.336.44-2.013.251a2.654 2.654 0 01-1.6-1.257 2.689 2.689 0 01-.249-2.029h-.078a2.39 2.39 0 01-1.365-.93 2.421 2.421 0 01.246-3.106c.4-.404.929-.652 1.493-.7a.684.684 0 000-.202c.064-.252.176-.49.33-.698a1.961 1.961 0 012.06-.734 1.99 1.99 0 011.308 1.054 1.74 1.74 0 011.744-.553c.462.12.859.419 1.106.831.246.413.322.906.21 1.374a2.06 2.06 0 01-.479.879l.061-.053z"
          fill="url(#prefix__paint12_radial_2677_202)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M65.583 4.314C64.947 2.627 66.455.061 67.938 0c1.482-.062 2.371.703 2.441 3.743 0 .747-.872 5.614-1.796 6.537-2.512.193-10.604-3.418-8.197-6.81 1.116-1.581 3.828-.377 5.232.88l-.035-.036z"
          fill="url(#prefix__paint13_radial_2677_202)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M73.824 13.996c-1.02-.58-4.081-4.393-1.744-5.465a1.498 1.498 0 011.772.525c.13.182.218.39.26.609.06-1.151 2.502-1.687 2.615.65 0 .984-1.744 3.101-2.886 3.681h-.017z"
          fill="url(#prefix__paint14_radial_2677_202)"
        />
        <path
          d="M57.648 91.42h.793c.332 0 .497-.193.524-.527l1.15-14.445h2.442l3.977 9.006c.41.95.872 2.18.872 2.18h.052s.427-1.23.872-2.18l3.976-9.005h2.46l1.15 14.444a.494.494 0 00.323.5.485.485 0 00.21.027h.81v2.082h-2.127c-1.108 0-1.465-.465-1.561-1.546l-.672-9.006a24.433 24.433 0 010-2.513h-.052s-.506 1.59-.872 2.513l-3.427 7.477h-2.014l-3.401-7.477c-.41-.878-.872-2.539-.872-2.539s0 1.52-.053 2.54l-.697 9.005c-.07 1.08-.454 1.546-1.526 1.546h-2.136l-.201-2.082zM84.924 80.991a6.316 6.316 0 013.48 1.164 6.39 6.39 0 012.26 2.908 6.442 6.442 0 01.288 3.683 6.41 6.41 0 01-1.781 3.229 6.332 6.332 0 01-3.257 1.698 6.304 6.304 0 01-3.645-.4 6.36 6.36 0 01-2.817-2.364 6.43 6.43 0 01-1.05-3.54c-.001-.853.169-1.699.499-2.486a6.38 6.38 0 011.422-2.093 6.326 6.326 0 012.12-1.37 6.289 6.289 0 012.48-.429zm0 10.772c.87.037 1.73-.19 2.47-.65a4.383 4.383 0 001.686-1.93 4.424 4.424 0 00-.825-4.848 4.33 4.33 0 00-4.772-1.038c-.807.326-1.499.888-1.987 1.614a4.417 4.417 0 00-.749 2.459 4.255 4.255 0 001.162 3.09 4.193 4.193 0 003.015 1.303zM99.129 80.991c3.427 0 5.232 2.557 5.232 5.72a5.7 5.7 0 01-.07.922h-8.842a4.138 4.138 0 001.229 2.96 4.078 4.078 0 002.965 1.17 5.593 5.593 0 003.567-1.424l.985 1.758a7.256 7.256 0 01-4.7 1.757 6.15 6.15 0 01-2.485-.424 6.187 6.187 0 01-2.11-1.387 6.28 6.28 0 01-1.822-4.62c0-3.92 2.615-6.432 6.05-6.432zm2.904 5.096c-.079-2.153-1.37-3.26-2.948-3.26a3.526 3.526 0 00-2.407.931 3.577 3.577 0 00-1.142 2.329h6.497zM1.517 103.958H.01v-2.003h10.464c1.081 0 1.534.457 1.534 1.546v8.136a.466.466 0 00.524.527h.985v2.004h-2.302c-1.073 0-1.535-.457-1.535-1.547v-8.136a.469.469 0 00-.311-.508.46.46 0 00-.212-.019h-5.32v10.21H1.518v-10.21zM16.054 104.485a.469.469 0 00-.312-.508.46.46 0 00-.212-.019h-.985v-2.003h2.18c1.081 0 1.491.457 1.491 1.23v.65h.044a4.372 4.372 0 011.71-1.659 4.334 4.334 0 012.318-.511c3.288 0 5.346 2.636 5.346 6.396 0 3.761-2.329 6.397-5.511 6.397a4.157 4.157 0 01-2.117-.474 4.196 4.196 0 01-1.598-1.477h-.052c.036.353.054.708.052 1.063V119H16.08l-.026-14.515zm5.702 7.969c1.901 0 3.488-1.59 3.488-4.393s-1.412-4.393-3.427-4.393c-1.796 0-3.488 1.283-3.488 4.393-.017 2.206 1.151 4.393 3.427 4.393zM35.734 101.665a6.31 6.31 0 013.481 1.164 6.391 6.391 0 012.26 2.91 6.441 6.441 0 01.287 3.684 6.41 6.41 0 01-1.784 3.229 6.31 6.31 0 01-6.904 1.292 6.36 6.36 0 01-2.816-2.367 6.435 6.435 0 01-1.046-3.542 6.407 6.407 0 011.922-4.577 6.29 6.29 0 014.6-1.793zm0 10.763c.87.037 1.73-.189 2.47-.649a4.383 4.383 0 001.687-1.931 4.423 4.423 0 00-.825-4.848 4.351 4.351 0 00-2.228-1.255 4.324 4.324 0 00-2.544.217c-.807.326-1.5.888-1.987 1.614a4.417 4.417 0 00-.75 2.459 4.248 4.248 0 001.16 3.093 4.183 4.183 0 003.017 1.3zM50.35 101.665c1.456 0 4.36.597 4.36 2.636v1.256h-2.111v-.676c0-.879-1.386-1.257-2.25-1.257a4.352 4.352 0 00-2.703 1.492 4.414 4.414 0 00.081 5.81 4.35 4.35 0 002.744 1.414 5.43 5.43 0 003.759-1.687l.985 1.661a6.601 6.601 0 01-2.238 1.574 6.546 6.546 0 01-2.68.526 6.329 6.329 0 01-4.481-1.892 6.41 6.41 0 01-1.841-4.531 6.44 6.44 0 01.493-2.446 6.39 6.39 0 013.45-3.447 6.283 6.283 0 012.431-.477v.044zM60.892 103.958h-2.346a.475.475 0 00-.497.318.483.483 0 00-.026.209v.826h-1.919v-1.863c0-1.089.454-1.493 1.535-1.493h8.816c1.081 0 1.535.404 1.535 1.493v1.863h-1.945v-.826a.483.483 0 00-.523-.527h-2.354v10.21h-2.302l.026-10.21zM70.458 104.485a.48.48 0 00-.138-.395.471.471 0 00-.394-.132h-.977v-2.003h2.18c1.081 0 1.482.457 1.482 1.23v.65a4.371 4.371 0 011.71-1.659 4.335 4.335 0 012.32-.511c3.278 0 5.336 2.636 5.336 6.396 0 3.761-2.32 6.397-5.511 6.397a4.185 4.185 0 01-2.116-.476 4.213 4.213 0 01-1.6-1.475V119h-2.319l.027-14.515zm5.702 7.969c1.893 0 3.488-1.59 3.488-4.393s-1.412-4.393-3.426-4.393c-1.797 0-3.488 1.283-3.488 4.393-.027 2.206 1.16 4.393 3.426 4.393zM90.828 106.568h.523v-.176c0-2.1-.811-2.873-2.677-2.873-.576 0-1.997.149-1.997.949v.694h-2.198v-1.23c0-1.96 3.044-2.267 4.142-2.267 4.003 0 5.058 2.047 5.058 4.78v5.192a.472.472 0 00.13.396.464.464 0 00.393.131h.986v2.004H92.98c-1.072 0-1.482-.528-1.482-1.397v-.73h-.052a4.263 4.263 0 01-1.602 1.787 4.218 4.218 0 01-2.305.63c-2.11 0-4.072-1.274-4.072-3.62.017-4.086 5.319-4.27 7.36-4.27zm-2.73 6.036c2.014 0 3.253-2.083 3.253-3.893v-.456h-.62c-1.743 0-4.909.166-4.909 2.363a2.077 2.077 0 00.707 1.495c.214.186.464.326.734.411.27.084.554.111.835.08zM97.533 104.485a.47.47 0 00-.311-.508.46.46 0 00-.212-.019h-.985v-2.003h2.284c1.082 0 1.535.457 1.535 1.546v3.453h6.104v-4.999h2.32v9.665a.48.48 0 00.137.395.464.464 0 00.394.132h.951v2.003h-2.276c-1.073 0-1.526-.457-1.526-1.546v-3.717h-6.104v5.272h-2.328l.017-9.674zM117.668 101.665c1.464 0 4.36.597 4.36 2.636v1.256h-2.111v-.676c0-.879-1.386-1.257-2.249-1.257a4.348 4.348 0 00-2.703 1.492 4.415 4.415 0 00.081 5.81 4.35 4.35 0 002.744 1.414 5.43 5.43 0 003.758-1.687l.985 1.661a6.6 6.6 0 01-2.238 1.574 6.547 6.547 0 01-2.68.526 6.33 6.33 0 01-4.481-1.892 6.416 6.416 0 01-1.841-4.531 6.437 6.437 0 011.878-4.515 6.339 6.339 0 014.497-1.855v.044zM128.184 103.958h-2.346a.476.476 0 00-.497.318.479.479 0 00-.026.209v.826h-1.918v-1.863c0-1.089.453-1.493 1.534-1.493h8.816c1.082 0 1.535.404 1.535 1.493v1.863h-1.918v-.826a.494.494 0 00-.139-.388.479.479 0 00-.385-.139h-2.354v10.21h-2.302v-10.21zM137.706 103.958h-1.517v-2.003h6.522c2.442 0 4.029 1.081 4.029 3.136a2.7 2.7 0 01-.446 1.605 2.669 2.669 0 01-1.298 1.031v.053a2.836 2.836 0 011.68 1.023c.422.531.643 1.196.622 1.876 0 2.267-1.822 3.471-4.456 3.471h-3.837c-.95 0-1.334-.404-1.334-1.327l.035-8.865zm4.595 3.137c1.369 0 2.085-.703 2.085-1.758 0-1.054-.742-1.757-2.154-1.757h-2.206v3.515h2.275zm-1.822 5.412h2.014c1.683 0 2.468-.756 2.468-1.933s-.872-1.907-2.468-1.907h-2.467v3.357a.438.438 0 00.113.349.437.437 0 00.155.106.433.433 0 00.185.028zM155.46 101.665a6.31 6.31 0 013.481 1.164 6.4 6.4 0 012.261 2.91 6.445 6.445 0 01.286 3.684 6.413 6.413 0 01-1.784 3.229 6.309 6.309 0 01-6.904 1.292 6.357 6.357 0 01-2.816-2.367 6.433 6.433 0 01-1.046-3.542 6.4 6.4 0 011.922-4.577 6.286 6.286 0 014.6-1.793zm0 10.763a4.326 4.326 0 002.472-.645 4.372 4.372 0 001.69-1.929 4.42 4.42 0 00-.819-4.851 4.356 4.356 0 00-2.227-1.257 4.328 4.328 0 00-2.545.215 4.366 4.366 0 00-1.989 1.614 4.42 4.42 0 00-.75 2.46 4.226 4.226 0 001.156 3.09 4.163 4.163 0 003.012 1.303z"
          fill="currentColor"
        />
      </g>
      <defs>
        <radialGradient
          id="prefix__paint0_radial_2677_202"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(30.2584 0 0 30.488 88.229 34.82)"
        >
          <stop stopColor="#04A678" />
          <stop offset={0.48} stopColor="#04A479" />
          <stop offset={0.65} stopColor="#059D7D" />
          <stop offset={0.77} stopColor="#079284" />
          <stop offset={0.87} stopColor="#09818E" />
          <stop offset={0.95} stopColor="#0D6B9B" />
          <stop offset={1} stopColor="#0F5BA4" />
        </radialGradient>
        <radialGradient
          id="prefix__paint1_radial_2677_202"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(30.2585 0 0 30.488 88.229 34.82)"
        >
          <stop stopColor="#04A678" />
          <stop offset={0.48} stopColor="#04A479" />
          <stop offset={0.65} stopColor="#059D7D" />
          <stop offset={0.77} stopColor="#079284" />
          <stop offset={0.87} stopColor="#09818E" />
          <stop offset={0.95} stopColor="#0D6B9B" />
          <stop offset={1} stopColor="#0F5BA4" />
        </radialGradient>
        <radialGradient
          id="prefix__paint2_radial_2677_202"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(25.4972 0 0 25.6908 62.148 40.82)"
        >
          <stop stopColor="#7D403E" />
          <stop offset={0.55} stopColor="#7B3E3D" />
          <stop offset={0.74} stopColor="#75373A" />
          <stop offset={0.88} stopColor="#6A2C35" />
          <stop offset={1} stopColor="#591A2E" />
        </radialGradient>
        <radialGradient
          id="prefix__paint3_radial_2677_202"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(25.4973 0 0 25.6908 62.147 40.82)"
        >
          <stop stopColor="#7D403E" />
          <stop offset={0.55} stopColor="#7B3E3D" />
          <stop offset={0.74} stopColor="#75373A" />
          <stop offset={0.88} stopColor="#6A2C35" />
          <stop offset={1} stopColor="#591A2E" />
        </radialGradient>
        <radialGradient
          id="prefix__paint4_radial_2677_202"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(15.3121 0 0 15.4285 47.629 53.587)"
        >
          <stop stopColor="#F08044" />
          <stop offset={0.49} stopColor="#F07E44" />
          <stop offset={0.66} stopColor="#EF7745" />
          <stop offset={0.79} stopColor="#ED6C46" />
          <stop offset={0.89} stopColor="#EA5B48" />
          <stop offset={0.97} stopColor="#E6454B" />
          <stop offset={1} stopColor="#E53C4C" />
        </radialGradient>
        <radialGradient
          id="prefix__paint5_radial_2677_202"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(15.3123 0 0 15.4285 47.629 53.587)"
        >
          <stop stopColor="#F08044" />
          <stop offset={0.49} stopColor="#F07E44" />
          <stop offset={0.66} stopColor="#EF7745" />
          <stop offset={0.79} stopColor="#ED6C46" />
          <stop offset={0.89} stopColor="#EA5B48" />
          <stop offset={0.97} stopColor="#E6454B" />
          <stop offset={1} stopColor="#E53C4C" />
        </radialGradient>
        <radialGradient
          id="prefix__paint6_radial_2677_202"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(13.0102 0 0 13.109 37.566 59.966)"
        >
          <stop stopColor="#FFD72E" />
          <stop offset={0.49} stopColor="#FFD52E" />
          <stop offset={0.67} stopColor="#FECE2E" />
          <stop offset={0.8} stopColor="#FBC32E" />
          <stop offset={0.9} stopColor="#F9B22D" />
          <stop offset={0.98} stopColor="#F59C2D" />
          <stop offset={1} stopColor="#F4972D" />
        </radialGradient>
        <radialGradient
          id="prefix__paint7_radial_2677_202"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(13.0103 0 0 13.109 37.566 59.966)"
        >
          <stop stopColor="#FFD72E" />
          <stop offset={0.49} stopColor="#FFD52E" />
          <stop offset={0.67} stopColor="#FECE2E" />
          <stop offset={0.8} stopColor="#FBC32E" />
          <stop offset={0.9} stopColor="#F9B22D" />
          <stop offset={0.98} stopColor="#F59C2D" />
          <stop offset={1} stopColor="#F4972D" />
        </radialGradient>
        <radialGradient
          id="prefix__paint8_radial_2677_202"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(18.0504 0 0 18.1874 110.944 47.577)"
        >
          <stop stopColor="#F08044" />
          <stop offset={0.49} stopColor="#F07E44" />
          <stop offset={0.66} stopColor="#EF7745" />
          <stop offset={0.79} stopColor="#ED6C46" />
          <stop offset={0.89} stopColor="#EA5B48" />
          <stop offset={0.97} stopColor="#E6454B" />
          <stop offset={1} stopColor="#E53C4C" />
        </radialGradient>
        <radialGradient
          id="prefix__paint9_radial_2677_202"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(18.0504 0 0 18.1874 110.944 47.577)"
        >
          <stop stopColor="#F08044" />
          <stop offset={0.49} stopColor="#F07E44" />
          <stop offset={0.66} stopColor="#EF7745" />
          <stop offset={0.79} stopColor="#ED6C46" />
          <stop offset={0.89} stopColor="#EA5B48" />
          <stop offset={0.97} stopColor="#E6454B" />
          <stop offset={1} stopColor="#E53C4C" />
        </radialGradient>
        <radialGradient
          id="prefix__paint10_radial_2677_202"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(10.5424 0 0 10.6225 125.472 61.468)"
        >
          <stop stopColor="#04A678" />
          <stop offset={0.48} stopColor="#04A479" />
          <stop offset={0.65} stopColor="#059D7D" />
          <stop offset={0.77} stopColor="#079284" />
          <stop offset={0.87} stopColor="#09818E" />
          <stop offset={0.95} stopColor="#0D6B9B" />
          <stop offset={1} stopColor="#0F5BA4" />
        </radialGradient>
        <radialGradient
          id="prefix__paint11_radial_2677_202"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(10.5425 0 0 10.6225 125.472 61.468)"
        >
          <stop stopColor="#04A678" />
          <stop offset={0.48} stopColor="#04A479" />
          <stop offset={0.65} stopColor="#059D7D" />
          <stop offset={0.77} stopColor="#079284" />
          <stop offset={0.87} stopColor="#09818E" />
          <stop offset={0.95} stopColor="#0D6B9B" />
          <stop offset={1} stopColor="#0F5BA4" />
        </radialGradient>
        <radialGradient
          id="prefix__paint12_radial_2677_202"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(4.82215 0 0 4.85876 127.312 59.904)"
        >
          <stop stopColor="#FFD72E" />
          <stop offset={0.49} stopColor="#FFD52E" />
          <stop offset={0.67} stopColor="#FECE2E" />
          <stop offset={0.8} stopColor="#FBC32E" />
          <stop offset={0.9} stopColor="#F9B22D" />
          <stop offset={0.98} stopColor="#F59C2D" />
          <stop offset={1} stopColor="#F4972D" />
        </radialGradient>
        <radialGradient
          id="prefix__paint13_radial_2677_202"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(5.16222 0 0 5.20142 65.165 5.14)"
        >
          <stop stopColor="#F08044" />
          <stop offset={0.49} stopColor="#F07E44" />
          <stop offset={0.66} stopColor="#EF7745" />
          <stop offset={0.79} stopColor="#ED6C46" />
          <stop offset={0.89} stopColor="#EA5B48" />
          <stop offset={0.97} stopColor="#E6454B" />
          <stop offset={1} stopColor="#E53C4C" />
        </radialGradient>
        <radialGradient
          id="prefix__paint14_radial_2677_202"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(2.7555 0 0 2.77643 73.963 11.202)"
        >
          <stop stopColor="#7D403E" />
          <stop offset={0.55} stopColor="#7B3E3D" />
          <stop offset={0.74} stopColor="#75373A" />
          <stop offset={0.88} stopColor="#6A2C35" />
          <stop offset={1} stopColor="#591A2E" />
        </radialGradient>
        <clipPath id="prefix__clip0_2677_202">
          <path fill="#fff" d="M0 0h162v119H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

const MemoLogo = React.memo(Logo);
export default MemoLogo;
